import { Box } from "@mui/material"
import { getCoreRowModel } from "@tanstack/react-table"
import type { FC } from "react"
import React, { useMemo } from "react"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import { useGetFileUploadData } from "@/components/upload/hooks/useGetFileUploadData"
import { ReferenceTableName } from "@/graphql/codegen/graphql"
import useHistoricCertificationColumns from "@/screens/Companies/edit/components/certification/hooks/useHistoricCertificationsColumns"
import type { GroupedByLocation } from "@/screens/Companies/edit/components/certification/types"
import { extractHistoryCertificationIds } from "@/screens/Companies/edit/components/certification/utils"

const HistoricCertificationTable: FC<{ data: GroupedByLocation[] }> = ({ data }) => {
  const certificationIds: string[] = useMemo(() => extractHistoryCertificationIds(data), [data])

  const { fileList } = useGetFileUploadData({
    referenceTableName: ReferenceTableName.Company,
    referenceIds: certificationIds,
    pause: !certificationIds.length,
  })

  const columns = useHistoricCertificationColumns({ fileData: fileList })

  return (
    <Box className='flex h-full flex-col'>
      <AerosBaseTable
        features={{
          table: {
            stickyHeader: true,
          },
          tanstackOptions: {
            data,
            columns,
            getCoreRowModel: getCoreRowModel(),
          },
        }}
        slotProps={{
          bodyRow: {
            className: "hover:bg-primary-100 cursor-pointer",
          },
        }}
        noDataMessage='No historic certificates found.'
      />
    </Box>
  )
}

export default HistoricCertificationTable
